// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"608":"addea741","930":"c56a1e2d"}[chunkId] + ".chunk.js";
};